import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { Track } from '../../api';
import * as colors from '../../api/style';

import { TextBold12 } from './Text';
import { Lock } from './Icons';
import Flex from './Flex';

export interface Props extends Partial<Pick<Track, 'visibility'>> {
  style?: CSSProperties;
  label?: boolean;
}

const TrackVisibilityStatus = ({ style, visibility, label = true }: Props) => {
  if (visibility) {
    return null;
  }

  return (
    <Flex color={colors.grey_main_new} alignItems="center" style={style}>
      <Lock size={14} />
      {label && <Label>Private</Label>}
    </Flex>
  );
};

const Label = styled(TextBold12)`
  text-transform: uppercase;
  margin-left: 5px;
`;

export default TrackVisibilityStatus;
